import { render, staticRenderFns } from "./WoozyDiamonds.vue?vue&type=template&id=b06593e4&"
import script from "./WoozyDiamonds.vue?vue&type=script&lang=js&"
export * from "./WoozyDiamonds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports